export default __webpack_public_path__ + "static/media/reply.9beace15.svg";